<script setup>
import { AbcHeading } from "@ordbogen-npm/abc-dsk";
import { useI18n } from "vue-i18n";

import ImageResponsive from "@/components/ImageResponsive.vue";
import ClassQuizBasePrompt from "@/components/vocabularyTrainer/ClassQuizBasePrompt.vue";

const props = defineProps({
  countdown: {
    type: Number,
    required: true
  }
});

const { t } = useI18n();
</script>

<template>
  <ClassQuizBasePrompt class="class-quiz-question-prompt row">
    <div class="col-lg-4 d-none d-lg-flex justify-content-end align-items-end">
      <ImageResponsive
        img-class="class-quiz-question-prompt__boy-image"
        src="/assets/img/vocab/game/boy-pointing@1x.png"
        presentational
      />
    </div>
    <div class="col-12 col-lg-4 d-flex justify-content-center align-items-center text-center">
      <AbcHeading
        tag="h1"
        size="xl"
        class="class-quiz-question-prompt__countdown"
        aria-live="polite"
        :aria-label="t('vocab.classQuiz.question.countdownLabel', { count: props.countdown })"
      >
        {{ props.countdown }}
      </AbcHeading>
    </div>
    <div class="col-lg-4 d-none d-lg-flex justify-content-start align-items-end">
      <ImageResponsive
        img-class="class-quiz-question-prompt__girl-image"
        src="/assets/img/vocab/game/girl-pointing@1x.png"
        presentational
      />
    </div>
  </ClassQuizBasePrompt>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.class-quiz-question-prompt {
  #media-breakpoint-up(lg, {
    padding-bottom: 0;
  });

  &__countdown {
    #media-breakpoint-up(lg, {
      margin-top: -3vmin;
    });
  }
}

:deep(.class-quiz-question-prompt__boy-image) {
  max-height: 12.5vmin;
}

:deep(.class-quiz-question-prompt__girl-image) {
  max-height: 15vmin;
}
</style>
